import React from 'react';
import Table from '../Table';
import { formatUnixTime } from '../../../utils';

const BatteryLogTable = ({ logs }) => {
  const headers = [
    'Timestamp',
    'PLC Battery Level',
    'HMI Battery Status',
    'PLC Battery Status',
  ];

  // Check if there are any logs
  if (!logs || logs.length === 0) {
    return <p className="font-bold text-error">No logs available.</p>; // Display message when logs are empty
  }

  const rows = logs.map((log) => [
    formatUnixTime(log.timestamp),
    log.plc_battery_level || 'N/A',
    log.hmi_battery_status || 'N/A',
    log.plc_battery_status || 'N/A',
  ]);

  return <Table headers={headers} rows={rows} />;
};

export default BatteryLogTable;
